import {Box, ToggleButton, ToggleButtonGroup} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';
import {bool, func} from 'prop-types';

import {FONT_FAMILIES} from '../../../../const';

const Container = muiStyled(Box)(() => ({
  minHeight: 42,
  display: 'flex',
  alignItems: 'center'
}));

const StyledToggleButtonsGroup = muiStyled(ToggleButtonGroup)(({theme}) => ({
  maxHeight: 40,
  width: '100%',
  borderRadius: 30,
  backgroundColor: theme.palette.primary.main,
  padding: '4px 4px 6px 4px'
}));

const SingleButton = muiStyled(props => <ToggleButton {...props} />)(({theme, ...props}) => ({
  width: '100%',
  border: 'none',
  color: props.selected ? 'primary' : 'white',
  backgroundColor: props.selected ? 'white !important' : 'primary',
  borderRadius: '30px !important',
  lineHeight: 1,
  fontFamily: FONT_FAMILIES.BODY,
  fontWeight: 'bold',
  fontSize: 13,
  margin: '2px 2px 0 2px'
}));

const CreateFromScratchOrCloneReportToggler = ({isCloningExistingReport, setIsCloningExistingReport}) => {
  const toggle = () => {
    setIsCloningExistingReport(!isCloningExistingReport);
  };

  return (
    <Container>
      <StyledToggleButtonsGroup color="primary" value={isCloningExistingReport} exclusive onChange={toggle} aria-label="Importer ou créer un rapport">
        <SingleButton selected={!isCloningExistingReport} value={isCloningExistingReport}>
          Créer un rapport vierge
        </SingleButton>
        <SingleButton selected={isCloningExistingReport} value={!isCloningExistingReport}>
          Cloner un rapport
        </SingleButton>
      </StyledToggleButtonsGroup>
    </Container>
  );
};

CreateFromScratchOrCloneReportToggler.propTypes = {
  isCloningExistingReport: bool.isRequired,
  setIsCloningExistingReport: func.isRequired
};

export default CreateFromScratchOrCloneReportToggler;
